import {Observer, observer} from "mobx-react-lite";
import {useStore} from "../../shared/context-provider/context-provider";
import {Button, Slide} from "@mui/material";
import {Field, Form as FinalForm} from "react-final-form";
import {FormCarType} from "../../shared/store/car-store";
import {InputSelectAdapter} from "../components/input-select-adapter";
import {InputAdapter} from "../components/input-adapter";
import {ColumnFields} from "../components/column-fields";
import styles from "../styles/form-plate.module.scss";
import {css} from "@emotion/css";
import {FormWithLoadedContent} from "../components/form-with-loaded-content";
import {
  WidgetPlateFieldSearch
} from "src/shared/input-search/widget-plate-search";
import {useEffect} from "react";

export const FormFirstVehicle = observer(() => {
  const {carStore} = useStore();

  useEffect(() => {
    carStore.loadServices();
  }, []);

  return (
    <Slide in={true} direction={carStore.directionSlide} timeout={500}>
      <div>
        <FinalForm<FormCarType>
          initialValues={carStore.formAggregate}
          onSubmit={(values) => {
            carStore.updateFormVehicle(values);
            carStore.nextStep();
          }}
          render={({form, handleSubmit, values, submitting}) => {
            return (
              <Observer>
                {() => {
                  const carDefined = !!carStore.carInfo && !carStore.isSearchingVehicle;
                  return (
                    <form onSubmit={handleSubmit} autoComplete={"off"}>
                      <h3 className={"widget-title"}>Get a Quote Now!</h3>
                      <WidgetPlateFieldSearch
                        fieldName={'plateNumber'}
                        styles={styles}
                        onPrintComplete={async (value) => {
                          await carStore.findVehicle(value);
                          carStore.trackSearch();
                          if (!carStore.carInfo) {
                            form.change("service", undefined);
                          }
                        }}/>
                      <FormWithLoadedContent
                        isSearching={submitting || carStore.isSearchingVehicle}
                        hideLoaderContent={!carDefined && !carStore.plateNumber}
                      >
                        <div className={styles.searchedVehicle}>
                          <div className={styles.icon}></div>
                          <div className={styles.name}>
                            {carStore.vehicleFullName}
                          </div>
                        </div>
                      </FormWithLoadedContent>

                      <ColumnFields className={css({
                        marginBlock: 15
                      })}>
                        <Field
                          label={'Select service*'}
                          name={"service"}
                          placeholder={"Select..."}
                          options={carStore.carServices.map((item) => ({
                            value: item.id.toString(),
                            label: item.name,
                          }))}
                          component={InputSelectAdapter}
                        />
                        <Field
                          name={"description"}
                          label={'More details'}
                          type={"text"}
                          component={InputAdapter}
                        />
                      </ColumnFields>

                      <Button
                        onClick={handleSubmit}
                        size={'large'}
                        sx={{
                          paddingX: 3,
                          borderRadius: 12
                        }}
                        disabled={!carDefined || !values["service"]}
                        variant={'contained'} color={'success'}>
                        Next Step
                      </Button>

                    </form>
                  )
                    ;
                }}
              </Observer>
            );
          }}
        />
      </div>
    </Slide>
  );
});
